module.exports = __webpack_public_path__ + "img/logo-mirt-horizontal.0c215180.svg";